var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTestimonialSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3710 3710",
    style: {
      enableBackground: "new 0 0 3710 3710"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 3710,
    height: 3710
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 4020.8159,
    y1: 3531.8335,
    x2: 1325.4519,
    y2: 1431.955
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M3069.784,2809.861c-437.972,562.306-1897.268,509.957-2371.5-323.861 c-225.333-396.193-219.39-953.215,61.156-1390.151c264.588-412.084,753.78-686.752,1201.86-634.48 C2923.933,573.667,3561.083,2179.091,3069.784,2809.861z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M923.143,475.897c-4.509-13.917,11.718-25.352,23.444-16.606 c119.079,88.809,411.987,361.99,407.667,898.073c-5.42,672.595,160.291,898.958,349.093,1027.063 c0,0-244.13-42.585-420.681-271.323C849.193,1551.499,1003.312,723.337,923.143,475.897z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1028.577,673.798c21.855,72.324,42.273,145.04,60.002,218.399 c18.111,73.252,33.995,147.021,47.555,221.178c13.275,74.203,25.156,148.644,33.857,223.479 c9.037,74.792,14.852,149.888,20.426,225.307c5.992,75.344,11.6,151.279,24.999,226.872 c13.302,75.446,35.824,150.517,71.395,219.247c8.886,17.127,18.119,34.158,28.262,50.476 c9.846,16.513,20.425,32.594,31.289,48.479c21.89,31.669,45.919,61.94,72.084,90.29 c52.484,56.575,113.542,105.114,179.217,144.603c6.912,4.156,15.885,1.921,20.042-4.991c4.081-6.787,2-15.562-4.622-19.812 l-0.047-0.03c-15.702-10.057-31.269-20.281-46.327-31.164c-7.618-5.322-14.983-10.971-22.452-16.479 c-7.251-5.784-14.729-11.288-21.793-17.29c-28.655-23.523-55.624-49.029-80.573-76.403 c-50.113-54.444-92.348-116.658-126.445-182.257c-16.683-33.002-30.906-67.176-42.449-102.326 c-11.518-35.162-20.352-71.264-27.132-107.897c-13.572-73.307-19.744-148.42-26.277-223.717 c-6.632-75.304-13.815-150.932-24.098-226.146c-5.039-37.616-10.754-75.137-17.138-112.538 c-3.084-18.717-6.53-37.372-9.942-56.029c-3.591-18.625-7.284-37.228-11.129-55.796c-15.515-74.25-33.288-147.99-53.365-221.066 c-20.428-72.979-42.786-145.392-67.895-216.821c-0.719-2.042-2.954-3.115-4.995-2.397 C1029.045,669.666,1027.978,671.806,1028.577,673.798z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1271.636,2629.63c-4.675,26.546-34.942,39.689-57.721,25.28 c-125.692-79.505-460.738-336.433-521.395-846.262c-51.222-430.528-119.909-659.11-158.281-760.718 c-8.114-21.486,15.917-40.842,35.205-28.374C782.249,1157.107,1441.051,1667.734,1271.636,2629.63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1235.723,2636.128c-0.485,0.46-1.019,0.878-1.605,1.25c-4.904,3.117-11.408,1.668-14.526-3.236 c-3.534-5.561-354.507-562.882-452.769-1158.285c-0.944-5.73,2.936-11.146,8.671-12.098c5.735-0.945,11.15,2.936,12.099,8.671 c97.545,591.069,446.253,1144.899,449.762,1150.423C1240.101,2627.172,1239.304,2632.732,1235.723,2636.128z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176013063686861897400000014033183901703762362_",
    gradientUnits: "userSpaceOnUse",
    x1: 3086.7227,
    y1: 653.3267,
    x2: 693.4223,
    y2: 3796.8601
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176013063686861897400000014033183901703762362_)"
    },
    d: "M1412.86,608.769l1497.547,16.491 c82.782,0.912,147.709,72.336,147.656,162.074l-1.331,2219.89c-0.038,62.102-50.318,113.61-110.963,113.878l-1605.521,7.084 c-56.649,0.25-103.118-47.13-103.118-105.299V798.114C1237.13,692.708,1315.797,607.701,1412.86,608.769z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2785.55,821.576H1526.76c-52.79,0-95.192,43.505-95.192,94.926v1832.093 c0,51.422,42.403,91.288,95.192,91.288h1258.79c52.79,0,95.976-39.866,95.976-91.288V916.502 C2881.526,865.08,2838.339,821.576,2785.55,821.576z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000000937084781958430440000014005568482032562347_",
    d: "M2785.55,821.576H1526.76 c-52.79,0-95.192,43.505-95.192,94.926v1832.093c0,51.422,42.403,91.288,95.192,91.288h1258.79 c52.79,0,95.976-39.866,95.976-91.288V916.502C2881.526,865.08,2838.339,821.576,2785.55,821.576z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000142141825490618736690000004506307502138167187_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000000937084781958430440000014005568482032562347_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000142141825490618736690000004506307502138167187_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106113436066945293900000011911604308429886643_",
    gradientUnits: "userSpaceOnUse",
    x1: 2101.8521,
    y1: 2483.9197,
    x2: 2775.991,
    y2: 845.5609,
    gradientTransform: "matrix(0.9998 -0.0189 0.0189 0.9998 -59.5478 19.4772)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106113436066945293900000011911604308429886643_)"
    },
    d: "M2801.608,1786.997 c-49.217-182.026-201.278-331.568-370.723-369.359c-31.133-6.944-49.161-38.66-41.854-69.708 c0.051-0.216,0.101-0.431,0.151-0.647c24.553-105.86-43.308-190.195-145.645-213.933 c-102.335-23.732-200.392,22.12-224.943,127.981c-16.57,71.44,4.654,151.806,51.638,203.847 c19.363,21.447,20.917,53.458,2.157,75.435c-103.259,120.967-145.265,305.605-100.611,470.753 c65.771,243.251,294.498,351.918,523.65,289.961C2724.579,2239.37,2867.378,2030.248,2801.608,1786.997z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075884006408162717490000007588429712782656385_",
    gradientUnits: "userSpaceOnUse",
    x1: 1966.7626,
    y1: 1923.8302,
    x2: 1410.0723,
    y2: 1448.1129
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000075884006408162717490000007588429712782656385_)"
    },
    d: "M1527.085,1443.906 c3.689-7.388,14.536-6.44,16.895,1.472c8.737,29.291,29.506,80.298,71.396,97.759c2.111,0.88,4.111,1.771,6.044,2.67 c1.778-5.685,1.681-12.245-2.963-19.058c-13.289-19.496,9.518-46.894,9.518-46.894s1.993,23.715,20.323,38.323 c15.789,12.585,23.793,41.1,13.614,64.809c-20.836,87.762-52.325,203.911,80.425,285.825 c132.747,81.913,312.851-165.229,312.851-165.229l-86.185,292.35c0,0-139.528,107.088-306.887-36.631 c-167.359-143.72-62.301-359.435-62.301-359.435S1473.323,1551.597,1527.085,1443.906z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000045577517294130321680000013567489987818758310_",
    gradientUnits: "userSpaceOnUse",
    x1: 3138.5623,
    y1: 1340.0886,
    x2: 2538.0718,
    y2: 1771.9027
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000045577517294130321680000013567489987818758310_)"
    },
    d: "M2066.833,1671.427 c39.01-12.502,152.833-36.374,263.383,61.846c18.749,16.659,26.768,42.356,20.653,66.68 c-27.155,107.995-98.162,426.882-28.052,562.956c0,0-116.503,133.405-248.3,30.144c0,0-63.03-252.723-141.414-362.712 c-54.117-75.933,78.521-290.464,112.125-342.323C2050.317,1680.166,2057.924,1674.284,2066.833,1671.427z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160911678222063474990000007630937456749408897_",
    gradientUnits: "userSpaceOnUse",
    x1: -6242.7266,
    y1: 2856.2166,
    x2: -6211.3188,
    y2: 2633.2209,
    gradientTransform: "matrix(0.9653 0.2612 -0.2612 0.9653 8856.9795 649.0368)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160911678222063474990000007630937456749408897_)"
    },
    d: "M2171.127,1455.922 c0,0,61.121,163.026,66.854,235.347c0,0-63.577,30.37-124.932-17.706c0,0-9.436-163.809-19.151-192.99L2171.127,1455.922z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127761566251554511160000011117803752612378757_",
    gradientUnits: "userSpaceOnUse",
    x1: -6386.7139,
    y1: 2378.3994,
    x2: -6093.0459,
    y2: 2716.0386,
    gradientTransform: "matrix(0.9653 0.2612 -0.2612 0.9653 8856.9795 649.0368)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000127761566251554511160000011117803752612378757_)"
    },
    d: "M2086.308,1233.667 c0,0-147.753,215.248-55.869,275.224c91.882,59.978,197.067-92.994,197.067-92.994s33.02-116.91-4.547-155.648 C2185.394,1221.509,2086.308,1233.667,2086.308,1233.667z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070098215286520991220000016186836135563427499_",
    gradientUnits: "userSpaceOnUse",
    x1: 1783.8237,
    y1: 2339.9263,
    x2: 2457.96,
    y2: 701.5742,
    gradientTransform: "matrix(0.9998 -0.0189 0.0189 0.9998 -59.5478 19.4772)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070098215286520991220000016186836135563427499_)"
    },
    d: "M2155.593,1181.588 c0,0-69.406,17.836-78.581,49.565c-9.176,31.73,100.016,58.931,130.482,59.786l26.932,126.83 c0,0,70.246-121.115,40.218-189.732C2244.616,1159.421,2155.593,1181.588,2155.593,1181.588z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000207780462173963600000003177141072382084491_",
    gradientUnits: "userSpaceOnUse",
    x1: -6313.3413,
    y1: 2314.5811,
    x2: -6019.6772,
    y2: 2652.2156,
    gradientTransform: "matrix(0.9653 0.2612 -0.2612 0.9653 8856.9795 649.0368)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000000207780462173963600000003177141072382084491_)"
    },
    d: "M2197.792,1400.826 c0,0,57.779-69.526,82.117-25.371c24.338,44.155-51.696,79.086-78.649,57.69L2197.792,1400.826z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029730083578903616300000001072018623751119250_",
    gradientUnits: "userSpaceOnUse",
    x1: 5337.6406,
    y1: 4346.6724,
    x2: 6038.2646,
    y2: 3109.9207,
    gradientTransform: "matrix(-1 0.0094 0.0094 1 7948.6538 -74.391)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000029730083578903616300000001072018623751119250_)"
    },
    d: "M1933.053,2928.839 c0.661,11.515-17.843,103.295-27.933,152.257c-4.061,19.698-0.588,40.17,9.73,57.435l393.432,634.57 c4.76,7.675,8.276,16.02,10.483,24.779c7.557,29.985,23.444,103.52,17.144,170.811l-18.951,41.341l84.946-20.98l14.235-229.455 l-24.43-14.271c-21.104-12.327-37.709-31.04-47.438-53.461c-36.061-83.102-125.709-294.681-149.743-398.164 c-27.313-117.609-160.251-211.042-160.251-211.042l22.008-54.899L1933.053,2928.839z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155853011972465950900000010290346370889194144_",
    gradientUnits: "userSpaceOnUse",
    x1: 5490.3784,
    y1: 3909.4138,
    x2: 5695.1763,
    y2: 3909.4138,
    gradientTransform: "matrix(-1 0.0094 0.0094 1 7948.6538 -74.391)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000155853011972465950900000010290346370889194144_)"
    },
    d: "M2495.229,3908.426 c0,0-47.45-72.171-53.406-100.5c-5.958-28.328-21.995-78.25-50.114-62.6c0,0-10.776,138.364-5.142,192.244 c5.632,53.879-60.021,53.383-60.021,53.383s-18.037,2.882-31.032,16.374c-8.973,9.317-2.133,25.056,10.788,25.644 c21.5,0.979,55.616,0.697,91.3-6.9c12.471-2.654,21.548-13.48,22.066-26.221l6.454-159.135l59.498,72.282L2495.229,3908.426z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000172425361378349555310000008405103465878971818_",
    gradientUnits: "userSpaceOnUse",
    x1: 6131.6055,
    y1: 3431.7585,
    x2: 5083.8335,
    y2: 3766.802,
    gradientTransform: "matrix(-1 0.0094 0.0094 1 7948.6538 -74.391)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000172425361378349555310000008405103465878971818_)"
    },
    d: "M2162.774,3026.765 c0,0,24.289,573.805,27.648,655.302c3.361,81.497-7.923,262.456-88.636,318.005l36.063,25.658 c0,0,43.732-38.614,85.783-112.135c47.236-82.595,61.704-97.795,61.704-97.795l-16.812-32.843 c-7.362-14.379-9.755-30.756-6.789-46.635c16.023-85.818,69.577-371.263,84.494-432.799 c17.608-72.639,17.134-169.189-50.398-248.74C2228.3,2975.233,2162.774,3026.765,2162.774,3026.765z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000082355786436931075470000017800043284763270273_",
    gradientUnits: "userSpaceOnUse",
    x1: 5680.2485,
    y1: 3946.3997,
    x2: 5924.3877,
    y2: 3946.3997,
    gradientTransform: "matrix(-1 0.0094 0.0094 1 7948.6538 -74.391)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000082355786436931075470000017800043284763270273_)"
    },
    d: "M2257.584,4049.352 c2.536-0.025,4.657-1.88,4.967-4.398c2.36-19.19,12.232-96.13,21.123-116.174c10.186-22.952,43.047-119.374-2.41-126.648 c0,0-109.519,166.673-130.719,189.265c-21.202,22.595-48.76,8.675-48.76,8.675s-20.946,6.622-36.448,27.221 c-7.378,9.805-0.068,23.854,12.204,23.74l75.873-0.709c22.036-0.207,41.599-13.964,49.402-34.571 c12.725-33.606,34.739-82.961,61.063-105.168l-11.38,133.279C2252.245,4046.835,2254.603,4049.381,2257.584,4049.352 L2257.584,4049.352z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160876092833523656420000016834884457060445367_",
    gradientUnits: "userSpaceOnUse",
    x1: 6013.5825,
    y1: 2304.4983,
    x2: 5428.7119,
    y2: 3608.2732,
    gradientTransform: "matrix(-1 0.0094 0.0094 1 7948.6538 -74.391)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160876092833523656420000016834884457060445367_)"
    },
    d: "M2055.393,2331.496 c0,0,18.123,54.165-6.445,144.406l-152.172,571.984c-2.391,8.988,2.611,18.253,11.422,21.228 c49.061,16.57,210.189,62.978,428.584,43.775c10.996-0.968,20.081-8.937,22.271-19.756 c13.185-65.129,58.169-287.345,67.432-333.004c35.299-173.979,74.839-361.629-116.753-471.027 C2223.124,2328.149,2142.102,2351.729,2055.393,2331.496z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000089563054278818895290000007227307783339189939_",
    gradientUnits: "userSpaceOnUse",
    x1: 5442.2598,
    y1: 2416.1431,
    x2: 6604.4814,
    y2: 1086.7323,
    gradientTransform: "matrix(-0.9944 -0.1059 -0.1059 0.9944 8217.1641 579.4497)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000089563054278818895290000007227307783339189939_)"
    },
    d: "M2346.167,1754.418 c0,0,188.27,150.544,238.245,360.173c49.976,209.627-266.462,237.982-266.462,237.982s-43.922-47.221-94.667-29.126 c-50.744,18.096-5.538-83.756,54.218-84.619c59.755-0.863,32.968,46.905,116.77,7.021 c81.634-38.85,130.349-155.161-83.033-326.046c-12.369-9.905-22.331-22.643-28.459-37.258 C2240.026,1780.58,2271.126,1712.624,2346.167,1754.418z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2730.345,2019.141l-4.454-3.125c41.023-58.222,46.29-142.266,13.74-219.325 c-25.848-61.21-72.105-117.178-145.572-176.134c-27.373-21.973-56.399-42.83-84.469-62.985 c-33.794-24.28-68.736-49.378-101.126-76.666c-29.133-24.556-59.785-55.023-66.211-94.876 c-3.21-19.868-0.213-41.033,2.689-61.497c4.539-32.029,8.823-62.283-9.95-85.447l4.231-3.423 c20.267,25.002,15.611,57.861,11.109,89.635c-2.844,20.059-5.783,40.81-2.711,59.86c6.15,38.099,35.978,67.673,64.351,91.58 c32.226,27.15,67.083,52.195,100.792,76.411c28.128,20.208,57.218,41.097,84.703,63.155 c74.2,59.551,120.968,116.2,147.183,178.26C2777.921,1873.346,2772.436,1959.399,2730.345,2019.141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2621.395,2054.275l-5.113-1.85c27.91-77.198,19.74-172.063-22.425-260.284 c-41.799-87.435-110.125-158.722-164.978-211.066l3.752-3.933c55.193,52.652,123.955,124.418,166.137,212.66 C2641.555,1879.32,2649.804,1975.716,2621.395,2054.275z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000122688848509007624050000001945392347848711089_",
    gradientUnits: "userSpaceOnUse",
    x1: 3205.3528,
    y1: -675.1314,
    x2: 2406.5684,
    y2: 253.6885
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000122688848509007624050000001945392347848711089_)"
    },
    d: "M1421.129,555.872 c184.617-4.02,1097.83-27.649,1285.257-32.507c18.495-0.479,33.656,21.548,33.656,48.885v126.36 c0,27.003-14.812,48.893-33.083,48.893H1421.635c-18.271,0-33.082-21.889-33.082-48.893V604.76 C1388.552,578.038,1403.05,556.266,1421.129,555.872z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000087414125759368169070000000483135144677414069_",
    gradientUnits: "userSpaceOnUse",
    x1: 2624.3132,
    y1: 323.6226,
    x2: 2411.8391,
    y2: 715.5184,
    gradientTransform: "matrix(0.9972 0.0747 -0.0747 0.9972 57.8919 24.8171)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000087414125759368169070000000483135144677414069_)"
    },
    d: "M2641.277,733.521l-46.517-24.365 c-3.617-1.895-7.936-1.888-11.548,0.018l-46.442,24.506c-9.095,4.799-19.746-2.914-18.023-13.052l8.798-51.769 c0.684-4.026-0.656-8.131-3.585-10.977l-37.658-36.596c-7.375-7.167-3.33-19.68,6.844-21.174l51.954-7.63 c4.04-0.593,7.53-3.137,9.332-6.802l23.168-47.124c4.537-9.229,17.687-9.249,22.253-0.034l23.311,47.053 c1.813,3.659,5.31,6.192,9.353,6.773l51.977,7.472c10.179,1.463,14.262,13.964,6.908,21.153l-37.547,36.711 c-2.92,2.855-4.248,6.964-3.552,10.987l8.956,51.742C2661.014,730.547,2650.387,738.293,2641.277,733.521z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010280166561188061680000003459369885346181564_",
    gradientUnits: "userSpaceOnUse",
    x1: 2376.3333,
    y1: 349.0665,
    x2: 2163.8591,
    y2: 740.9624,
    gradientTransform: "matrix(0.9972 0.0747 -0.0747 0.9972 57.8919 24.8171)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000010280166561188061680000003459369885346181564_)"
    },
    d: "M2392.091,740.37l-46.517-24.365 c-3.618-1.895-7.936-1.888-11.548,0.018l-46.442,24.506c-9.095,4.799-19.746-2.914-18.023-13.052l8.798-51.769 c0.684-4.026-0.656-8.131-3.585-10.977l-37.658-36.596c-7.375-7.167-3.33-19.68,6.844-21.174l51.954-7.63 c4.04-0.593,7.53-3.137,9.332-6.802l23.168-47.124c4.537-9.229,17.687-9.249,22.252-0.034l23.312,47.054 c1.813,3.659,5.31,6.192,9.353,6.773l51.977,7.472c10.179,1.463,14.261,13.964,6.908,21.153l-37.547,36.711 c-2.92,2.855-4.248,6.964-3.552,10.988l8.956,51.742C2411.828,737.396,2401.201,745.141,2392.091,740.37z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000050650793865029397470000015079989696854476177_",
    gradientUnits: "userSpaceOnUse",
    x1: 2134.998,
    y1: 368.4966,
    x2: 1922.524,
    y2: 760.3925,
    gradientTransform: "matrix(0.9972 0.0747 -0.0747 0.9972 57.8919 24.8171)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000050650793865029397470000015079989696854476177_)"
    },
    d: "M2149.98,741.718l-46.517-24.365 c-3.617-1.895-7.936-1.888-11.547,0.018l-46.442,24.506c-9.095,4.799-19.746-2.914-18.023-13.052l8.798-51.769 c0.684-4.026-0.656-8.131-3.585-10.977l-37.658-36.596c-7.375-7.167-3.33-19.679,6.844-21.174l51.954-7.63 c4.04-0.593,7.53-3.137,9.332-6.802l23.168-47.124c4.537-9.229,17.687-9.249,22.253-0.034l23.312,47.053 c1.813,3.659,5.31,6.192,9.352,6.773l51.977,7.472c10.179,1.463,14.262,13.964,6.908,21.153l-37.547,36.711 c-2.92,2.855-4.248,6.964-3.552,10.988l8.956,51.742C2169.717,738.744,2159.09,746.489,2149.98,741.718z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000086663146362973915510000006691987312750804102_",
    gradientUnits: "userSpaceOnUse",
    x1: 1900.8459,
    y1: 388.802,
    x2: 1688.3719,
    y2: 780.6979,
    gradientTransform: "matrix(0.9972 0.0747 -0.0747 0.9972 57.8919 24.8171)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000086663146362973915510000006691987312750804102_)"
    },
    d: "M1914.967,744.475l-46.517-24.365 c-3.618-1.895-7.936-1.888-11.547,0.018l-46.442,24.506c-9.095,4.799-19.746-2.914-18.023-13.052l8.798-51.769 c0.684-4.026-0.656-8.131-3.585-10.977l-37.658-36.596c-7.375-7.167-3.33-19.68,6.844-21.174l51.954-7.63 c4.04-0.593,7.53-3.137,9.332-6.802l23.168-47.124c4.537-9.229,17.687-9.249,22.252-0.034l23.311,47.054 c1.813,3.659,5.31,6.192,9.353,6.773l51.977,7.472c10.179,1.463,14.262,13.964,6.909,21.153l-37.547,36.711 c-2.92,2.855-4.248,6.964-3.552,10.987l8.956,51.742C1934.703,741.501,1924.077,749.247,1914.967,744.475z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000038397055762217875860000010413125084373781124_",
    gradientUnits: "userSpaceOnUse",
    x1: 1826.4705,
    y1: 731.2568,
    x2: 1512.6995,
    y2: 1146.2448
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000038397055762217875860000010413125084373781124_)"
    },
    d: "M1683.701,1311.848l-110.954-69.29 c-8.629-5.388-19.357-6.186-28.687-2.132l-119.98,52.12c-23.497,10.207-48.499-10.96-42.308-35.819l31.612-126.935 c2.458-9.872-0.098-20.321-6.837-27.942l-86.645-98.003c-16.969-19.193-4.563-49.511,20.992-51.305l130.491-9.161 c10.148-0.712,19.296-6.373,24.462-15.136l66.431-112.689c13.01-22.069,45.678-19.64,55.281,4.11l49.036,121.274 c3.813,9.431,12.023,16.382,21.955,18.587l127.702,28.357c25.009,5.553,32.794,37.373,13.174,53.846l-100.185,84.112 c-7.791,6.541-11.865,16.497-10.893,26.623l12.493,130.215C1733.287,1308.181,1705.43,1325.418,1683.701,1311.848z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000051372378341547210150000003878242938811893411_",
    gradientUnits: "userSpaceOnUse",
    x1: 7923.7329,
    y1: 2032.1261,
    x2: 8000.0503,
    y2: 2032.1261,
    gradientTransform: "matrix(1 0 0 1 -7025.4556 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000051372378341547210150000003878242938811893411_)"
    },
    d: "M908.901,2005.234 c0,0-8.48,13.368-10.614,50.794c-0.199,3.487,2.564,6.458,6.056,6.458h66.326c2.669,0,4.573-2.617,3.719-5.145 c-3.887-11.503-15.638-39.549-41.859-55.575L908.901,2005.234z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000040532762924878883790000007804832499071688113_",
    gradientUnits: "userSpaceOnUse",
    x1: 7931.4746,
    y1: 1996.662,
    x2: 7962.4263,
    y2: 1996.662,
    gradientTransform: "matrix(1 0 0 1 -7025.4556 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000040532762924878883790000007804832499071688113_)"
    },
    d: "M906.019,1979.873l3.751,31.456 c0.324,2.714,2.451,4.886,5.166,5.199c3.627,0.418,8.901,0.712,14.025-0.133c4.658-0.768,8.01-4.917,8.01-9.638v-30.371 L906.019,1979.873z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109022518619422831050000010946855474731872135_",
    gradientUnits: "userSpaceOnUse",
    x1: 8086.0317,
    y1: 2030.9056,
    x2: 8205.7773,
    y2: 2030.9056,
    gradientTransform: "matrix(1 0 0 1 -7025.4556 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109022518619422831050000010946855474731872135_)"
    },
    d: "M1073.004,2001.766 c0,0-12.695,19.733-12.423,46.818c0.064,6.38,5.405,11.461,11.785,11.461h103.011c4.824,0,6.782-6.198,2.835-8.97 c-19.493-13.688-57.805-39.259-85.516-49.309H1073.004z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000135665434452211478530000007599738240460144056_",
    gradientUnits: "userSpaceOnUse",
    x1: 8087.8506,
    y1: 1982.9182,
    x2: 8118.6318,
    y2: 1982.9182,
    gradientTransform: "matrix(1 0 0 1 -7025.4556 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000135665434452211478530000007599738240460144056_)"
    },
    d: "M1062.395,1967.796l8.002,38.848 c0.895,4.345,5.146,7.267,9.475,6.301c2.633-0.588,5.738-1.713,9.056-3.787c3.153-1.972,4.751-5.724,4.107-9.386l-8.277-47.065 L1062.395,1967.796z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145025686004425900140000008188997898926246325_",
    gradientUnits: "userSpaceOnUse",
    x1: 7912.2427,
    y1: 1709.8796,
    x2: 8122.0898,
    y2: 1709.8796,
    gradientTransform: "matrix(1 0 0 1 -7025.4556 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145025686004425900140000008188997898926246325_)"
    },
    d: "M920.717,1427.665 c0,0-27.822,24.528-33.058,54.039c-5.236,29.511,14.835,509.16,14.835,509.16s27.82,4.629,42.162-4.061 c0,0,17.01-311.289,29.94-383.22c0,0,67.806,322.454,86.593,380.718c0,0,26.803,3.261,35.446-1.839 c0,0-17.761-417.991-40.08-492.304L920.717,1427.665z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011733627647938925970000004947669667332223371_",
    gradientUnits: "userSpaceOnUse",
    x1: 933.0621,
    y1: 1559.5853,
    x2: 977.1606,
    y2: 1559.5853
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000011733627647938925970000004947669667332223371_)"
    },
    d: "M973.782,1593.817 c-1.499,0-2.866-1.005-3.261-2.524l-11.485-44.057l-24.422-15.665c-1.568-1.005-2.023-3.094-1.018-4.662 s3.094-2.033,4.662-1.018l25.532,16.377c0.715,0.458,1.229,1.17,1.443,1.99l11.817,45.335c0.471,1.802-0.609,3.644-2.415,4.115 C974.352,1593.781,974.065,1593.817,973.782,1593.817z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000042700016478956111470000018191556886044641697_",
    gradientUnits: "userSpaceOnUse",
    x1: 1456.0315,
    y1: 778.447,
    x2: 1260.3656,
    y2: 1055.0784
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000042700016478956111470000018191556886044641697_)"
    },
    d: "M1195.271,1150.514 c-117.121-9.723-147.732,14.514-147.732,14.514l56.284,88.856c0,0,115.082-2.273,197.543-65.831 c-15.432-16.62-26.151-34.988-33.025-49.29C1247.078,1147.6,1222.591,1152.782,1195.271,1150.514z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062879277582023637090000014382276545424754598_",
    gradientUnits: "userSpaceOnUse",
    x1: 8293.7979,
    y1: 1093.7042,
    x2: 8410.3799,
    y2: 1093.7042,
    gradientTransform: "matrix(1 0 0 1 -7025.4556 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000062879277582023637090000014382276545424754598_)"
    },
    d: "M1340.144,1021.602 c-7.919-7.11-15.557-14.533-22.89-22.247c-0.578,13.579,5.025,27.302,14.942,36.596c5.672,5.315,12.682,9.272,17.375,15.468 c24.14,31.869-60.498,78.729-81.229,87.344c6.874,14.302,17.592,32.669,33.026,49.289 c21.267-16.391,39.642-36.489,53.213-59.708c7.095-12.138,10.805-27.188,18.326-38.49c5.201-7.816,13.396-13.834,11.819-26.203 c-0.942-7.388-7.609-12.484-13.615-16.89C1360.382,1038.892,1350.044,1030.491,1340.144,1021.602z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165943907723362677050000016697067508005290422_",
    gradientUnits: "userSpaceOnUse",
    x1: 1245.8969,
    y1: 1176.498,
    x2: 901.7955,
    y2: 1611.6857
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165943907723362677050000016697067508005290422_)"
    },
    d: "M1233.823,1202.03 c-41.231-44.428-119.766-64.501-165.236-72.746c-19.92-3.613-39.557,7.472-46.615,26.447 c-20.463,55.006-76.114,198.111-86.901,222.706c-8.85,20.178-18.09,39.885-23.961,52.206c-3.508,7.36-0.443,16.169,6.903,19.709 c38.255,18.439,107.092,39.302,134.999,47.441c6.139,1.79,12.251-2.819,12.251-9.213c0-5.422,1.474-10.745,4.265-15.394 l105.692-176.127c65.877,73.043,123.567,79.722,167.886,63.734c-7.452-23.03-12.328-46.103-14.667-69.219 C1262.966,1280.359,1233.823,1202.03,1233.823,1202.03z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000126317382891842271780000005741999606862021780_",
    gradientUnits: "userSpaceOnUse",
    x1: 8552.834,
    y1: 1106.5446,
    x2: 8305.6504,
    y2: 1414.0642,
    gradientTransform: "matrix(1 0 0 1 -7025.4556 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000126317382891842271780000005741999606862021780_)"
    },
    d: "M1436.654,1279.316l-11.816-15.754 c-38.252,26.271-70.226,32.497-96.401,28.013c2.339,23.117,7.215,46.189,14.667,69.219 C1401.489,1339.732,1436.654,1279.316,1436.654,1279.316z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054226608591129113650000018012047362000765826_",
    gradientUnits: "userSpaceOnUse",
    x1: 8599.6982,
    y1: 1144.214,
    x2: 8352.5156,
    y2: 1451.7338,
    gradientTransform: "matrix(1 0 0 1 -7025.4556 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054226608591129113650000018012047362000765826_)"
    },
    d: "M1428.323,1279.601l66.566,2.595 l61.288-34.231c-8.798-5.515-58.547,5.757-58.547,5.757s-52.006-7.865-66.082-7.884c-11.691-0.015-10.02,16.796-9.119,22.493 c0.184,1.162,0.336,1.862,0.336,1.862L1428.323,1279.601z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000151508288940213461370000011871580509170241413_",
    gradientUnits: "userSpaceOnUse",
    x1: 8274.751,
    y1: 920.6948,
    x2: 8035.3525,
    y2: 1360.5667,
    gradientTransform: "matrix(1 0 0 1 -7025.4556 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000151508288940213461370000011871580509170241413_)"
    },
    d: "M1131.129,1047.689l-35.122,85.705 c0,0,40.355,27.932,72.822,25.274l17.528-77.064L1131.129,1047.689z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132066298054587049370000016714576450562432429_",
    gradientUnits: "userSpaceOnUse",
    x1: 7146.8228,
    y1: 1763.6588,
    x2: 7115.8735,
    y2: 1661.5807,
    gradientTransform: "matrix(0.9721 -0.2346 0.2346 0.9721 -6173.4214 1052.8702)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132066298054587049370000016714576450562432429_)"
    },
    d: "M1211.705,1027.985 c0,0,5.021,52.371-10.672,72.637c-15.692,20.266-56.417,17.688-78.43-17.394l9.75-71.422L1211.705,1027.985z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008864682561817724910000018131257891134310788_",
    gradientUnits: "userSpaceOnUse",
    x1: 7118.8931,
    y1: 1576.2257,
    x2: 7147.668,
    y2: 1740.3496,
    gradientTransform: "matrix(0.9721 -0.2346 0.2346 0.9721 -6173.4214 1052.8702)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008864682561817724910000018131257891134310788_)"
    },
    d: "M1139.675,1054.734 c1.594,0.12,2.915-1.202,2.774-2.795c-0.426-4.844-0.906-14.517,1.122-21.674c0,0-3.459-6.195,17.607-0.66 c21.067,5.535,52.629,13.517,66.997,0.76c14.009-12.438,19.895-59.441-20.661-41.207c-1.543,0.694-3.34-0.235-3.615-1.905 c-1.187-7.205-5.82-23.322-23.574-24.568c-16.614-1.167-23.382,7.839-25.849,12.885c-0.726,1.484-2.633,1.919-3.917,0.879 c-6.08-4.92-21.736-14.736-38.254-2.13c-13.605,10.384-13.709,20.333-12.048,26.116c0.538,1.874-1.073,3.62-2.986,3.243 c-5.181-1.022-12.95-0.328-17.962,10.408c-6.928,14.841,9.869,22.207,14.81,24.009c0.81,0.295,1.429,0.959,1.636,1.795 c1.602,6.462,9.423,34.448,27.415,46.957c1.558,1.083,3.724,0.133,4.028-1.741l4.629-28.585c0.215-1.328,1.41-2.27,2.751-2.169 L1139.675,1054.734z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170962683112418228310000016074172237410655913_",
    gradientUnits: "userSpaceOnUse",
    x1: 7114.7656,
    y1: 1773.379,
    x2: 7083.8164,
    y2: 1671.3009,
    gradientTransform: "matrix(0.9721 -0.2346 0.2346 0.9721 -6173.4214 1052.8702)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000170962683112418228310000016074172237410655913_)"
    },
    d: "M1141.177,1059.948 c0,0-13.192-25.489-21.174-14.253c-7.982,11.236,9.431,27.523,21.897,28.419L1141.177,1059.948z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000035518069556441639470000007413248979098077368_",
    gradientUnits: "userSpaceOnUse",
    x1: 199.2354,
    y1: 2194.6536,
    x2: 995.1685,
    y2: 3695.0334,
    gradientTransform: "matrix(-1 0.0033 0.0033 1 1814.5869 9.8832)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000035518069556441639470000007413248979098077368_)"
    },
    d: "M1387.162,3244.654 c-5.348,0.018-9.698-4.303-9.715-9.651l-3.834-1157.424c-0.018-5.348,4.303-9.697,9.651-9.715 c5.349-0.018,9.698,4.302,9.715,9.651l3.834,1157.424C1396.831,3240.287,1392.511,3244.636,1387.162,3244.654z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000071557769328938707500000005269571646171434661_",
    gradientUnits: "userSpaceOnUse",
    x1: 404.0154,
    y1: 2086.0249,
    x2: 1199.9484,
    y2: 3586.4045,
    gradientTransform: "matrix(-1 0.0033 0.0033 1 1814.5869 9.8832)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000071557769328938707500000005269571646171434661_)"
    },
    d: "M1124.755,3245.523 c-5.348,0.018-9.698-4.303-9.715-9.651l-3.834-1157.424c-0.018-5.348,4.303-9.697,9.651-9.715 c5.348-0.018,9.697,4.302,9.715,9.651l3.834,1157.424C1134.423,3241.156,1130.103,3245.506,1124.755,3245.523z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026147175987205155290000018070252863393027764_",
    gradientUnits: "userSpaceOnUse",
    x1: 712.3972,
    y1: 1922.4336,
    x2: 1508.3298,
    y2: 3422.8127,
    gradientTransform: "matrix(-1 0.0033 0.0033 1 1814.5869 9.8832)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026147175987205155290000018070252863393027764_)"
    },
    d: "M480.077,3255 c-1.265,0.004-2.548-0.241-3.787-0.762c-4.928-2.075-7.241-7.753-5.165-12.685l491.311-1166.401 c2.075-4.928,7.762-7.236,12.682-5.164c4.928,2.076,7.241,7.753,5.165,12.684L488.972,3249.074 C487.419,3252.763,483.842,3254.988,480.077,3255z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000019667158267401955060000011674808538855624077_",
    gradientUnits: "userSpaceOnUse",
    x1: 473.7076,
    y1: 2049.0515,
    x2: 1269.6403,
    y2: 3549.4304,
    gradientTransform: "matrix(-1 0.0033 0.0033 1 1814.5869 9.8832)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000019667158267401955060000011674808538855624077_)"
    },
    d: "M785.937,3253.987 c-1.265,0.004-2.548-0.241-3.787-0.762c-4.928-2.075-7.241-7.753-5.165-12.684l491.311-1166.402 c2.077-4.928,7.76-7.235,12.682-5.164c4.928,2.076,7.241,7.753,5.165,12.684l-491.31,1166.402 C793.279,3251.75,789.703,3253.974,785.937,3253.987z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137847176677157459180000016446051688779590807_",
    gradientUnits: "userSpaceOnUse",
    x1: 638.0438,
    y1: 1966.6763,
    x2: 1553.0161,
    y2: 3691.4519,
    gradientTransform: "matrix(-1 0.0033 0.0033 1 1814.5869 9.8832)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000137847176677157459180000016446051688779590807_)"
    },
    d: "M1396.13,2088.157l-527.902,1.749 c-8.773,0.029-15.905-6.058-15.93-13.595l0,0c-0.025-7.537,7.066-13.671,15.839-13.7l527.902-1.749 c8.772-0.029,15.904,6.058,15.929,13.595l0,0C1411.993,2081.994,1404.902,2088.128,1396.13,2088.157z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000058575212128626819970000016920546272806816153_",
    gradientUnits: "userSpaceOnUse",
    x1: 625.9404,
    y1: 1968.2876,
    x2: 1421.8937,
    y2: 3468.7053,
    gradientTransform: "matrix(-1 0.0033 0.0033 1 1814.5869 9.8832)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000058575212128626819970000016920546272806816153_)"
    },
    d: "M1203.034,2265.93l-306.767,1.016 c-5.348,0.018-9.697-4.303-9.715-9.651c-0.018-5.348,4.302-9.698,9.651-9.715l306.767-1.016c5.348-0.018,9.698,4.303,9.715,9.651 S1208.383,2265.913,1203.034,2265.93z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096021504748668638750000005169085303769193603_",
    gradientUnits: "userSpaceOnUse",
    x1: 608.1954,
    y1: 1977.6962,
    x2: 1404.1499,
    y2: 3478.1165,
    gradientTransform: "matrix(-1 0.0033 0.0033 1 1814.5869 9.8832)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000096021504748668638750000005169085303769193603_)"
    },
    points: "1109.638,2486.528  802.871,2487.544 802.807,2468.179 1109.574,2467.163  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054987305414242816820000000186062415801638291_",
    gradientUnits: "userSpaceOnUse",
    x1: 588.1067,
    y1: 1988.3473,
    x2: 1384.056,
    y2: 3488.7578,
    gradientTransform: "matrix(-1 0.0033 0.0033 1 1814.5869 9.8832)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000054987305414242816820000000186062415801638291_)"
    },
    points: "1019.244,2707.116  712.478,2708.132 712.414,2688.766 1019.18,2687.75  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049191998206983383940000009945147666272562065_",
    gradientUnits: "userSpaceOnUse",
    x1: 571.4793,
    y1: 1997.1608,
    x2: 1367.4333,
    y2: 3497.5801,
    gradientTransform: "matrix(-1 0.0033 0.0033 1 1814.5869 9.8832)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049191998206983383940000009945147666272562065_)"
    },
    d: "M924.414,2927.719l-306.767,1.016 c-5.348,0.018-9.698-4.302-9.715-9.651c-0.018-5.349,4.303-9.698,9.651-9.715l306.767-1.016c5.348-0.018,9.698,4.303,9.715,9.651 S929.762,2927.702,924.414,2927.719z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083066896966971670270000013878867770085512348_",
    gradientUnits: "userSpaceOnUse",
    x1: 552.376,
    y1: 2007.2888,
    x2: 1348.3273,
    y2: 3507.7031,
    gradientTransform: "matrix(-1 0.0033 0.0033 1 1814.5869 9.8832)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083066896966971670270000013878867770085512348_)"
    },
    d: "M832.755,3148.315l-306.766,1.016 c-5.348,0.018-9.698-4.302-9.715-9.65c-0.018-5.348,4.303-9.698,9.651-9.715l306.766-1.016c5.349-0.018,9.698,4.303,9.715,9.651 C842.424,3143.948,838.104,3148.298,832.755,3148.315z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestimonialSvg);
export default __webpack_public_path__ + "static/media/testimonial-svg.e3babf2f74dd723bde450a4f589b4b3d.svg";
export { ForwardRef as ReactComponent };